import EFVideoModal from '@/components/UI/EFVideoModal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { IPageStatus } from '../../config/IPageStatus';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import { useProductPageStatus } from '../../ProductProvider';
import { icon1, icon2, icon3, icon4 } from './icons';
import css from './index.module.scss';
interface IconType {
    text: string;
    icon: React.ReactNode;
}
interface ItemType {
    name: string;
    text?: string;
    img: string[];
    mark: string;
    icons?: IconType[];
    gtmTitle: string;
    webp: string[];
    hide?: boolean;
}

const C: React.FC = () => {
    const { t } = useLang('dpux');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-C');
    const [enter, setEnter] = useState(false);
    const { locale = '' } = useRouter();
    const pageStatus = useProductPageStatus();
    const items: ItemType[] = [
        {
            name: t.rich('C_box1_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t.rich('C_box1_text', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            img:
                locale === 'ca'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1762495447877/pc-1.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1762495446641/m-1.jpg',
                      ]
                    : [
                          'https://websiteoss.ecoflow.com/upload/image/1758939590762/pc_KSP_1.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1758939652214/m_KSP_1.jpg',
                      ],
            webp:
                locale === 'ca'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1762495566296/pc-1.webp',
                          'https://websiteoss.ecoflow.com/upload/image/1762495566732/m-1.webp',
                      ]
                    : [
                          'https://websiteoss.ecoflow.com/upload/image/1758939479577/pc_KSP_1.webp',
                          'https://websiteoss.ecoflow.com/upload/image/1758939480867/m_KSP_1.webp',
                      ],
            mark: locale === 'ca' ? '#delta-pro-ultra-x-H' : '#delta-pro-ultra-x-J',
            gtmTitle: t('J_title'),
        },
        {
            name: t.rich('C_box2_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('C_box2_text'),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1760080387660/pc_KSP_2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760080388191/m_KSP_2.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1760080464537/pc_KSP_2.webp',
                'https://websiteoss.ecoflow.com/upload/image/1760080464192/m_KSP_2.webp',
            ],
            mark: '#delta-pro-ultra-x-G',
            gtmTitle: t('G_title'),
        },
        {
            name: t.rich('C_box3_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('C_box3_text'),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1759045179842/C_pc_KSP_3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760000709009/m_KSP_3.jpg',
            ],
            webp: ['', ''],
            mark: '#delta-pro-ultra-x-I',
            gtmTitle: t('I_title'),
            hide: locale === 'ca',
        },
        {
            name: t.rich('C_box4_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('C_box4_text'),
            img:
                locale === 'ca'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1762495447381/pc-4.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1762495447068/m-4.jpg',
                      ]
                    : [
                          'https://websiteoss.ecoflow.com/upload/image/1760080387492/pc_KSP_4.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1760080388002/m_KSP_4.jpg',
                      ],
            webp:
                locale === 'ca'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1762495566136/pc-4.webp',
                          'https://websiteoss.ecoflow.com/upload/image/1762495566929/m-4.webp',
                      ]
                    : [
                          'https://websiteoss.ecoflow.com/upload/image/1760080463833/pc_KSP_4.webp',
                          'https://websiteoss.ecoflow.com/upload/image/1760080463966/m_KSP_4.webp',
                      ],
            mark: '#delta-pro-ultra-x-NumberAni',
            gtmTitle: t('NumberAni.title'),
        },
        {
            name: t.rich('C_box5_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('C_box5_text'),
            img:
                locale === 'ca'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1762495446802/pc-5.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1762510097984/m-5.jpg',
                      ]
                    : [
                          'https://websiteoss.ecoflow.com/upload/image/1758939591084/pc_KSP_5.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1758939651332/m_KSP_5.jpg',
                      ],
            webp:
                locale === 'ca'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1762495565974/pc-5.webp',
                          'https://websiteoss.ecoflow.com/upload/image/1762510098169/m-5.webp',
                      ]
                    : [
                          'https://websiteoss.ecoflow.com/upload/image/1758939478798/pc_KSP_5.webp',
                          'https://websiteoss.ecoflow.com/upload/image/1758939480014/m_KSP_5.webp',
                      ],
            mark: '#delta-pro-ultra-x-H',
            gtmTitle: t('H_title'),
        },
        {
            name: t.rich('C_box6_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1758939590854/pc_KSP_6.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758939651121/m_KSP_6.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1758939478558/pc_KSP_6.webp',
                'https://websiteoss.ecoflow.com/upload/image/1758939479780/m_KSP_6.webp',
            ],
            mark: '#delta-pro-ultra-x-Tabs',
            icons: [
                {
                    text: t('C_box6_icon1'),
                    icon: icon1,
                },
                {
                    text: t('C_box6_icon2'),
                    icon: icon2,
                },
                {
                    text: t('C_box6_icon3'),
                    icon: icon3,
                },
                {
                    text: t('C_box6_icon4'),
                    icon: icon4,
                },
            ],
            gtmTitle: t('Tabs.title'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneCArr: any[] = [];
            const info: HTMLElement | null = document.querySelector('.delta-pro-ultra-x-C .info');
            if (info) {
                sceneCArr.push(
                    AniContainer.create({
                        triggerElement: '.delta-pro-ultra-x-C .info',
                        triggerHook: 1,
                        offset: '20%',
                        duration: '100%',
                        onEnter: () => setEnter(true),
                        onProcess: (process: number) => {
                            if (process <= 0) {
                                setEnter(false);
                            }
                        },
                    }),
                );
            }
            return () => {
                sceneCArr.forEach((item: any) => item.destroy());
            };
        }
    }, []);

    // youtu 视频
    const [youtube, setYoutube] = useState<string>('');
    const handlePlay = () => {
        setYoutube('https://www.youtube.com/embed/T5ucOsi-EQM?si=wpAGw1427fxwuTDQ');
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('A_title'),
            position: 'Product Detail_1',
            __btn_id1: `delta-pro-ultra-x-C .video`,
            __btn_id2: 'dpux-c-video',
            __btn_type: 'common',
        });
    };

    return (
        <>
            <section
                className={`${css.section} delta-pro-ultra-x-C GtmModuleData-section ${pageStatus === IPageStatus.REGULAR ? 'hide-D' : ''}`}
                id="delta-pro-ultra-x-C"
                data-section-id={'delta-pro-ultra-x-C'}
                data-section-title={t('C_title')}
            >
                <div className={`info ${enter ? 'enter' : ''}`}>
                    <p className="title">{t('C_title')}</p>
                    {locale === 'us' && (
                        <div className="video GtmModuleData-btn-common" data-btn-id="dpux-c-video" onClick={handlePlay}>
                            <span>{t('C_video_btn')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 0C18.4188 9.184e-05 23.6219 5.20325 23.6221 11.6221C23.6221 18.0411 18.419 23.245 12 23.2451C5.58094 23.2451 0.376953 18.0411 0.376953 11.6221C0.377169 5.2032 5.58108 0 12 0ZM10.5996 7.25488C10.2154 6.97769 9.67902 7.25189 9.67871 7.72559V15.5195C9.67878 15.9935 10.2153 16.2676 10.5996 15.9902L15.999 12.0938C16.3204 11.8618 16.3204 11.3833 15.999 11.1514L10.5996 7.25488Z"
                                    fill="#3f68e0"
                                />
                            </svg>
                        </div>
                    )}
                </div>
                <div className={`items ${enter ? 'enter' : ''}`}>
                    {items.map((item: ItemType, k: number) =>
                        item.hide ? null : (
                            <EcoLink
                                key={item.name}
                                className={`item item-${k + 1} GtmModuleData-btn-common`}
                                data-btn-id={item.mark}
                                href={item.mark}
                                style={{ gridArea: `g${k + 1}` }}
                                onClick={() => {
                                    // 当前滚动距离
                                    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                                    window.sessionStorage.setItem('toTop-scrollTop', scrollTop.toString());
                                }}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'click_anchor',
                                    position: item.gtmTitle,
                                    button_name: item.name,
                                    __btn_id1: `${css.section} .item-${k + 1}`,
                                    __btn_id2: item.mark,
                                    __btn_type: 'common',
                                }}
                            >
                                <div className="item-ani">
                                    <EcoImg
                                        className="item-img"
                                        pc={webpOrJpg(item.img[0], item.webp[0])}
                                        pad={webpOrJpg(item.img[0], item.webp[0])}
                                        h5={webpOrJpg(item.img[1], item.webp[1])}
                                    />
                                    <div className={k === 0 ? 'item-info item-info-1' : 'item-info'}>
                                        <div className="item-content">
                                            <p className="item-name">{item.name}</p>
                                            {item?.text && <p className="item-text">{item.text}</p>}
                                            <div className="item-icons">
                                                {item?.icons?.map((icon: IconType) => (
                                                    <div key={icon.text} className="item-icon">
                                                        {icon.icon}
                                                        <p className="item-icon-text">{icon.text}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {k === 0 && <div className="tip">{t('tip')}</div>}
                                    </div>

                                    <span className="item-link"></span>
                                </div>
                            </EcoLink>
                        ),
                    )}
                </div>
            </section>
            <EFVideoModal visible={Boolean(youtube)} source={youtube} onClose={() => setYoutube('')} playerType={'YouTube'} />
        </>
    );
};

export default C;
